import React from "react";
import InfoBox from "../../common/template/infoBox";
import Grid from "../../common/layout/grid";
import charging90 from "../../assets/images/battery-level-90-charging.svg";
import charging50 from "../../assets/images/battery-level-50-charging.svg";
import charging20 from "../../assets/images/battery-level-20-charging.svg";
import Select from "react-select";

const optionsDesempenho = [
    { value: "instantaneo", label: "Instantâneo" },
    { value: "diario", label: "Diário" },
    { value: "mensal", label: "Mensal" },
    { value: "anual", label: "Anual" },
];

export function CardsStatusProducao({
    lista,
    filtroDesempenhoOtimo,
    setFiltroDesempenhoOtimo,
    filtroDesempenhoModerado,
    setFiltroDesempenhoModerado,
    filtroDesempenhoBaixo,
    setFiltroDesempenhoBaixo,
    coresStatus,
}) {
    const verdeOuAmarela = (item) => item.corStatus === coresStatus.STATUS_COR_VERDE || item.corStatus === coresStatus.STATUS_COR_AMARELA;

    const totalUsinasOperandoNormalmente = lista.filter((item) => verdeOuAmarela(item)).length;
    const totalUsinasSemComunicacao = lista.filter((item) => item.corStatus === coresStatus.STATUS_COR_VERMELHA).length;

    const totalUsinasProducaoOtima = lista.filter(
        (item) => verdeOuAmarela(item) && item["desempenho_solar_" + filtroDesempenhoOtimo.valor] > 93 //potencia é otimo acima de 93
    ).length;

    const totalUsinasProducaoModerada = lista.filter(
        (item) => verdeOuAmarela(item) && item["desempenho_solar_" + filtroDesempenhoModerado.valor] >= 81 && item["desempenho_solar_" + filtroDesempenhoModerado.valor] <= 93 //potencia é moderada de 81 a 93, inclusive
    ).length;
    const totalUsinasProducaoBaixa = lista.filter(
        (item) => verdeOuAmarela(item) && item["desempenho_solar_" + filtroDesempenhoBaixo.valor] < 81 //potencia é ruim abaixo de 30
    ).length;

    //----------------------------------------------------------------------
    return (
        <>
            <Grid cols="12 6 6 6" style={{ paddingLeft: window.innerWidth < 992 ? 0 : null }}>
                <InfoBox icon="fas fa-check" text="Operando Normalmente" number={totalUsinasOperandoNormalmente} twoColors="#3EFF3E" minHeight={50} />
            </Grid>
            <Grid cols="12 6 6 6" style={{ paddingLeft: window.innerWidth < 992 ? 0 : null }}>
                <InfoBox icon="fas fa-exclamation-triangle" text="Sem Comunicação ou Desligado" number={totalUsinasSemComunicacao} twoColors="#F56969" minHeight={50} />
            </Grid>
            <Grid cols="12 12 4 4" style={{ paddingLeft: window.innerWidth < 992 ? 0 : null }}>
                <InfoBox
                    text={
                        <span>
                            Desempenho Ótimo (<b>{totalUsinasProducaoOtima}</b>)
                        </span>
                    }
                    twoColors="#4AE30E"
                    minHeight={50}
                    childrenColumn={true}
                    checked={filtroDesempenhoOtimo.ativado}
                    onClick={() => {
                        setFiltroDesempenhoBaixo({ ...filtroDesempenhoBaixo, ativado: false });
                        setFiltroDesempenhoModerado({ ...filtroDesempenhoModerado, ativado: false });
                        setFiltroDesempenhoOtimo({ valor: "instantaneo", ativado: !filtroDesempenhoOtimo.ativado });
                    }}
                >
                    <img
                        src={charging90}
                        style={{
                            height: 30,
                            width: 30,
                            filter: "brightness(0) invert(1)",
                        }}
                        alt=""
                    />
                    <div style={{ minWidth: "85%" }}>
                        <Select
                            value={optionsDesempenho.find((item) => item.value === filtroDesempenhoOtimo.valor)}
                            isDisabled={!filtroDesempenhoOtimo.ativado}
                            isClearable={false}
                            isSearchable={false}
                            isMulti={false}
                            onChange={(item) => setFiltroDesempenhoOtimo({ ...filtroDesempenhoOtimo, valor: item.value })}
                            options={optionsDesempenho}
                        />
                    </div>
                </InfoBox>
            </Grid>
            <Grid cols="12 12 4 4" style={{ paddingLeft: window.innerWidth < 992 ? 0 : null }}>
                <InfoBox
                    text={
                        <span>
                            Desempenho Moderado (<b>{totalUsinasProducaoModerada}</b>)
                        </span>
                    }
                    twoColors="#FFE53C"
                    minHeight={50}
                    childrenColumn={true}
                    checked={filtroDesempenhoModerado.ativado}
                    onClick={() => {
                        setFiltroDesempenhoBaixo({ ...filtroDesempenhoBaixo, ativado: false });
                        setFiltroDesempenhoOtimo({ ...filtroDesempenhoOtimo, ativado: false });
                        setFiltroDesempenhoModerado({ valor: "instantaneo", ativado: !filtroDesempenhoModerado.ativado });
                    }}
                >
                    <img
                        src={charging50}
                        style={{
                            height: 30,
                            width: 30,
                            filter: "brightness(0) invert(1)",
                        }}
                        alt=""
                    />
                    <div style={{ minWidth: "85%" }}>
                        <Select
                            value={optionsDesempenho.find((item) => item.value === filtroDesempenhoModerado.valor)}
                            isDisabled={!filtroDesempenhoModerado.ativado}
                            isClearable={false}
                            isSearchable={false}
                            isMulti={false}
                            onChange={(item) => setFiltroDesempenhoModerado({ ...filtroDesempenhoModerado, valor: item.value })}
                            options={optionsDesempenho}
                        />
                    </div>
                </InfoBox>
            </Grid>
            <Grid cols="12 12 4 4" style={{ paddingLeft: window.innerWidth < 992 ? 0 : null }}>
                <InfoBox
                    text={
                        <span>
                            Desempenho Baixo (<b>{totalUsinasProducaoBaixa}</b>)
                        </span>
                    }
                    twoColors="#FF3838"
                    minHeight={50}
                    childrenColumn={true}
                    checked={filtroDesempenhoBaixo.ativado}
                    onClick={() => {
                        setFiltroDesempenhoModerado({ ...filtroDesempenhoModerado, ativado: false });
                        setFiltroDesempenhoOtimo({ ...filtroDesempenhoOtimo, ativado: false });
                        setFiltroDesempenhoBaixo({ valor: "instantaneo", ativado: !filtroDesempenhoBaixo.ativado });
                    }}
                >
                    <img
                        src={charging20}
                        style={{
                            height: 30,
                            width: 30,
                            filter: "brightness(0) invert(1)",
                        }}
                        alt=""
                    />
                    <div style={{ minWidth: "85%" }}>
                        <Select
                            value={optionsDesempenho.find((item) => item.value === filtroDesempenhoBaixo.valor)}
                            isDisabled={!filtroDesempenhoBaixo.ativado}
                            isClearable={false}
                            isSearchable={false}
                            isMulti={false}
                            onChange={(item) => setFiltroDesempenhoBaixo({ ...filtroDesempenhoBaixo, valor: item.value })}
                            options={optionsDesempenho}
                        />
                    </div>
                </InfoBox>
            </Grid>
        </>
    );
}
